// export const classes = [{ Dubai: "compact-wrapper" }];
export const classes = [{ Byte_Nfc: "compact-wrapper" }];
